import { Button } from 'components/buttons'
import { Icon } from 'components/icon'
import { Typography } from 'components/typography'
import { addDays, format } from 'date-fns'
import { Icons, TypographyTypes } from 'interfaces'
import React from 'react'
import { ViewTypeCalendar } from 'utils'

export const CalendarHeader: React.FC<{
	view: ViewTypeCalendar
	currentMonth: Date
	firstCalendarDay: Date
	prevPeriod: () => void
	prevMonth: () => void
	changeView: (typeView: ViewTypeCalendar) => void
	nextPeriod: () => void
	nextMonth: () => void
}> = ({
	view,
	prevPeriod,
	prevMonth,
	currentMonth,
	firstCalendarDay,
	changeView,
	nextPeriod,
	nextMonth
}): JSX.Element => {
	const monthName = currentMonth.toLocaleString('default', { month: 'long' })
	const year = currentMonth.getFullYear()

	const formattedHeader = (): JSX.Element => {
		if (view === 'week') {
			return (
				<div className="flex items-center gap-1">
					<Typography
						title={`${format(firstCalendarDay, 'MMMM dd')}`}
						type={TypographyTypes.h2}
						className="text-gray-9"
						fontLeading="22/27"
					/>
					<Typography
						title={`${format(firstCalendarDay, 'yyyy')}`}
						type={TypographyTypes.h3}
						className="text-[20px] !font-light text-gray-9"
					/>
					-
					<Typography
						title={format(addDays(firstCalendarDay, 6), 'MMMM dd')}
						type={TypographyTypes.h2}
						fontLeading="22/27"
						className="text-gray-9"
					/>
					<Typography
						title={`${format(addDays(firstCalendarDay, 6), 'yyyy')}`}
						type={TypographyTypes.h3}
						className="text-[20px] !font-light text-gray-9"
					/>
				</div>
			)
		}
		return (
			<div className="flex items-center gap-1">
				<Typography
					title={monthName}
					type={TypographyTypes.h2}
					fontLeading="22/27"
					className="text-gray-9"
				/>
				<Typography
					title={year.toString()}
					type={TypographyTypes.h3}
					className="text-[20px] !font-light ml-1 text-gray-9"
				/>
			</div>
		)
	}

	return (
		<header className="flex items-center justify-between border-b border-gray-200 px-6 py-4 lg:flex-none">
			<div className="flex items-center justify-between gap-4">
				<button
					type="button"
					className="flex h-[32px] w-[32px] items-center justify-center rounded-full border border-gray-300 hover:cursor-pointer"
					onClick={view === 'week' ? prevPeriod : prevMonth}
				>
					<Icon
						fillPath
						src={Icons.arrowLeft}
						className="w-7 text-blue-primary"
					/>
				</button>
				{formattedHeader()}

				<button
					type="button"
					className="flex h-[32px] w-[32px] items-center justify-center rounded-full border border-gray-300 hover:cursor-pointer"
					onClick={view === 'week' ? nextPeriod : nextMonth}
				>
					<Icon
						fillPath
						src={Icons.arrowRight}
						className="w-[24px] text-blue-primary"
					/>
				</button>
			</div>
			<div className="flex items-center">
				<div className="flex items-center justify-between gap-2">
					<Button
						type="button"
						label="Week"
						color={view === 'week' ? 'Primary' : 'white'}
						className="!min-w-[91px] border-gray-3 border-[1px]"
						onClick={() => changeView('week')}
					/>
					<Button
						type="button"
						label="Month"
						color={view === 'month' ? 'Primary' : 'white'}
						className="!min-w-[91px] border-gray-3 border-[1px]"
						onClick={() => changeView('month')}
					/>
				</div>
			</div>
		</header>
	)
}
